import { useMutation, useQueryClient } from "@tanstack/react-query";
import { axiosInstance } from "@retro-ia/shared/axios";
import { toast } from "sonner";

interface SummaryResponse {
  pdfUrl: string;
  summary: string;
  metadata: {
    tipo: string;
    nombre: string;
    total_feedbacks: number;
  };
}

interface UseGenerateSummaryActividadOptions {
  onSuccess?: (data: SummaryResponse) => void;
}

export function useGenerateSummaryActividad(
  options?: UseGenerateSummaryActividadOptions
) {
  const queryClient = useQueryClient();

  return useMutation<SummaryResponse, Error, number>({
    mutationFn: async (idActividad: number) => {
      const response = await axiosInstance.post(
        `/reportes/actividad/${idActividad}/summary`,
        {
          llm_provider: "OpenAI",
        },
        {
          timeout: 120000, // 2 minutos de timeout
        }
      );
      return response.data;
    },
    onSuccess: (data, idActividad) => {
      // Invalidar query del último reporte para refrescar
      queryClient.invalidateQueries({
        queryKey: ["lastReport", "actividad", idActividad],
      });

      // Llamar callback opcional
      if (options?.onSuccess) {
        options.onSuccess(data);
      }

      toast.success("Reporte generado exitosamente");
    },
    onError: (error: any) => {
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "Error al generar reporte";
      toast.error(errorMessage);
    },
  });
}
